import { isPwa as isPwaBrowser } from '../browser'

/**
 * Checks whether the current document is running as an installed PWA
 * (standalone display-mode, iOS home-screen, or Android TWA).
 *
 * @returns A Promise that resolves to true if the app is running as a PWA.
 * @example
 * ```ts
 * if (await montilla.isPwa()) {
 *   montilla.track('pwa_session_started')
 * }
 * ```
 */
export function isPwa(): Promise<boolean> {
  return Promise.resolve(isPwaBrowser())
}
